class ConfiguratorCartItems extends HTMLElement {
  constructor() {
    (super(),
      (this.lineItemStatusElement = document.getElementById('shopping-cart-line-item-status')),
      (this.currentItemCount = Array.from(this.querySelectorAll('[name="updates[]"]')).reduce(
        (total, quantityInput) => total + parseInt(quantityInput.value),
        0,
      )),
      (this.debouncedOnChange = debounce((event) => {
        this.onChange(event);
      }, 300)),
      this.addEventListener('change', this.debouncedOnChange.bind(this)));
  }
  onChange(event) {
    this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'));
  }
  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section',
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents',
      },
    ];
  }
  updateQuantity(line, quantity, name) {
    this.enableLoading(line);
    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });
    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), body })
      .then((response) => response.text())
      .then((state) => {
        const parsedState = JSON.parse(state);
        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartFooter = document.getElementById('main-cart-footer');
        (cartFooter && cartFooter.classList.toggle('is-empty', parsedState.item_count === 0),
          this.getSectionsToRender().forEach((section) => {
            const elementToReplace =
              document.getElementById(section.id).querySelector(section.selector) ||
              document.getElementById(section.id);
            elementToReplace.innerHTML = this.getSectionInnerHTML(
              parsedState.sections[section.section],
              section.selector,
            );
          }),
          this.updateLiveRegions(line, parsedState.item_count));
        const lineItem = document.getElementById(`CartItem-${line}`);
        (lineItem && lineItem.querySelector(`[name="${name}"]`) && lineItem.querySelector(`[name="${name}"]`).focus(),
          this.disableLoading());
      })
      .catch(() => {
        (this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden')),
          (document.getElementById('cart-errors').textContent = window.cartStrings.error),
          this.disableLoading());
      });
  }
  updateLiveRegions(line, itemCount) {
    (this.currentItemCount === itemCount &&
      (document.getElementById(`Line-item-error-${line}`).querySelector('.cart-item__error-text').innerHTML =
        window.cartStrings.quantityError.replace('[quantity]', document.getElementById(`Quantity-${line}`).value)),
      (this.currentItemCount = itemCount),
      this.lineItemStatusElement.setAttribute('aria-hidden', !0));
    const cartStatus = document.getElementById('cart-live-region-text');
    (cartStatus.setAttribute('aria-hidden', !1),
      setTimeout(() => {
        cartStatus.setAttribute('aria-hidden', !0);
      }, 1e3));
  }
  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }
  enableLoading(line) {
    this.lineItemStatusElement &&
      (document.getElementById('main-cart-items').classList.add('cart__items--disabled'),
      this.querySelectorAll(`#CartItem-${line} .loading-overlay`).forEach((overlay) =>
        overlay.classList.remove('hidden'),
      ),
      document.activeElement.blur(),
      this.lineItemStatusElement.setAttribute('aria-hidden', !1));
  }
  disableLoading() {
    document.getElementById('main-cart-items').classList.remove('cart__items--disabled');
  }
}
customElements.define('configurator-cart-items', ConfiguratorCartItems);
//# sourceMappingURL=/s/files/1/0636/0265/5480/t/58/assets/configurator-cart.js.map?v=1723521173
